"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComputedDataSection = getComputedDataSection;
const jsonpath_1 = __importDefault(require("jsonpath"));
/**
 * Returns the computed data section of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data section
 */
function getComputedDataSection(data) {
    const computedData = jsonpath_1.default.query(data, '$.Section[?(@.TOCHeading==="Chemical and Physical Properties")]' +
        '.Section[?(@.TOCHeading==="Computed Properties")]');
    return computedData;
}
//# sourceMappingURL=getComputedDataSection.js.map